export default __webpack_public_path__ + "0f63210bcb92cb538f3c587ca2b52277.png";